import Vue from 'vue'
import Router from 'vue-router'

import Home from '../pages/Home'
import Login from '../pages/Login'
import Index from '../pages/Index'
import Main from '../pages/Main'

import Demo from '../demo/demo1.vue'
import ReloadCurrent from '../pages/ReloadCurrent'

// 数据看板
import InventoryDynamic from '../pages/dataBoard/InventoryDynamic'
import DeliveryTrail from '../pages/dataBoard/DeliveryTrail'
// import StoreMap from '../pages/dataBoard/StoreMap'
import BigDataIndex from '../pages/dataBoard/bigDataBoard/BigDataIndex'
import ProductSale from '../pages/dataBoard/bigDataBoard/ProductSale'
import SellPlan from '../pages/dataBoard/bigDataBoard/SellPlan'
import SellAreaDay from '../pages/dataBoard/bigDataBoard/SellAreaDay'
import SellAreaWeek from '../pages/dataBoard/bigDataBoard/SellAreaWeek'
import SpecialBoard from '../pages/dataBoard/bigDataBoard/SpecialBoard'
import ProfitData from '../pages/dataBoard/bigDataBoard/ProfitDataIndex'

// 库存管理
import InventoryManage from '../pages/inventoryManage/InventoryManage'
import InventoryInfo from '../pages/inventoryManage/InventoryInfo'
import InventoryWarnning from '../pages/inventoryManage/InventoryWarnning'
import NewInventoryOrder from '../pages/inventoryManage/NewInventoryOrder'
import CheckInventory from '../pages/inventoryManage/CheckInventory'

// 订单管理
import OrderManage from '../pages/orderManage/OrderManage'
import ProductInfo from '../pages/orderManage/ProductInfo'
import OrderList from '../pages/orderManage/OrderList'
import FeiYouOrderList from '../pages/orderManage/FeiYouOrderList'
import PurchaseOrderList from '../pages/orderManage/PurchaseOrderList'
import MyPurchaseOrder from '../pages/orderManage/MyPurchaseOrder'
import OrderDetailCheck from '../pages/orderManage/OrderDetailCheck'
import OrderDetailLook from '../pages/orderManage/OrderDetailLook'
import MaintainRecord from '../pages/orderManage/MaintainRecord'

// 数据监控
import DataControl from '../pages/dataControl/DataControl'

// 配送管理
import DeliveryManage from '../pages/deliveryManage/DeliveryManage'
import DeliveryList from '../pages/deliveryManage/DeliveryList'
import DeliverySetting from '../pages/deliveryManage/DeliverySetting'

// 用户管理
import UserManage from '../pages/userManage/UserManage'
import UserList from '../pages/userManage/UserList'
import AddUser from '../pages/userManage/AddUser'

// 电子券管理
import TicketManage from '../pages/ticketManage/TicketManage'

// 营销管理
import MarketingManage from '../pages/marketingManage/MarketingManage'
import MsgRecordAll from '../pages/marketingManage/MsgRecordAll'
import NewOrderList from "../pages/orderManage/NewOrderList";
import OrderInSystem from "../pages/orderManage/orderInSystem";
import OrderServiceProvider from "../pages/orderManage/OrderServiceProvider";
// 数据看板
var baseDir = '';

Vue.use(Router)
let routes = [
    {
        path: baseDir+'',
        redirect: baseDir+'/index'
    },
    // home
    {
        name: 'home',
        path: baseDir+'/home',
        component: Home
    },
    // login
    {
        name: 'login',
        path: baseDir+'/login',
        component: Login
    },
    // main
    {
        name: 'main',
        path: baseDir+'/main',
        component: Main
    },
    // demo
    {
        name: 'demo',
        path: baseDir+'/demo',
        component: Demo
    },
    // index
    {
        name: 'index',
        path: baseDir+'/index',
        component: Index,
        // redirect: baseDir + '/index/storemap',
        redirect: baseDir + '/index/bigdataindex/sellareaday',
        children: [
            {
                name: 'reloadcurrent',
                path: baseDir + '/index/reloadcurrent',
                component: ReloadCurrent
            },
            // 数据看板
            // 库存动态
            {
                name: 'inventorydynamic',
                path: baseDir + '/index/inventorydynamic',
                component: InventoryDynamic
            },
            // 汽服门店网络图
            {
                name: 'storemap',
                path: baseDir + '/index/storemap',
                component: () => import('@/pages/dataBoard/StoreMap')
            },
            // 大数据看板
            {
                name: 'bigdataindex',
                path: baseDir + '/index/bigdataindex',
                component: BigDataIndex,
                redirect: baseDir + '/index/bigdataindex/sellareaday',
                children: [
                    // 产销衔接
                    {
                        name: 'productsale',
                        path: baseDir + '/index/bigdataindex/productsale',
                        component: ProductSale
                    },
                    // 销售计划完成情况
                    {
                        name: 'sellplan',
                        path: baseDir + '/index/bigdataindex/sellplan',
                        component: SellPlan
                    },
                    // 日报看板
                    {
                        name: 'sellareaday',
                        path: baseDir + '/index/bigdataindex/sellareaday',
                        component: SellAreaDay
                    },
                    
                    // 销售计划完成情况
                    {
                        name: 'sellareaweek',
                        path: baseDir + '/index/bigdataindex/sellareaweek',
                        component: SellAreaWeek
                    },
                    // 特种油看板
                    {
                        name: 'specialboard',
                        path: baseDir + '/index/bigdataindex/specialboard',
                        component: SpecialBoard
                    },
                ]
            },
            // // 利润看板
            // {
            //     name: 'profitdata',
            //     path: baseDir + '/index/profitdataindex/profitdata',
            //     component: ProfitData
            // },
            {
                name: 'profitdataindex',
                path: baseDir + '/index/profitdataindex',
                component: ProfitData,
                redirect: baseDir + '/index/profitdataindex/profitdata',
                children: [
                    // // 利润看板
                    {
                        name: 'profitdata',
                        path: baseDir + '/index/profitdataindex/profitdata',
                        component: ProfitData
                    },
                ]
            },
            // 配送轨迹
            {
                name: 'deliverytrail',
                path: baseDir + '/index/deliverytrail',
                component: DeliveryTrail
            },
            // 库存管理
            {
                name: 'inventorymanage',
                path: baseDir + '/index/inventorymanage',
                component: InventoryManage,
                redirect: baseDir + '/index/inventorymanage/inventoryinfo',
                children: [
                    {
                        name: 'inventoryinfo',
                        path: baseDir + '/index/inventorymanage/inventoryinfo',
                        component: InventoryInfo
                    },
                    {
                        name: 'inventorywarnning',
                        path: baseDir + '/index/inventorymanage/inventorywarnning',
                        component: InventoryWarnning
                    },
                    {
                        name: 'newinventoryorder',
                        path: baseDir + '/index/inventorymanage/newinventoryorder',
                        component: NewInventoryOrder
                    },
                    {
                        name: 'checkinventory',
                        path: baseDir + '/index/inventorymanage/checkinventory',
                        component: CheckInventory
                    }
                ]
            },
            // 订单管理
            {
                name: 'ordermanage',
                path: baseDir + '/index/ordermanage',
                component: OrderManage,
                redirect: baseDir + '/index/ordermanage/productinfo',
                children: [
                    {
                        name: 'productinfo',
                        path: baseDir + '/index/ordermanage/productinfo',
                        component: ProductInfo
                    },
                    {
                        name: 'orderlist',
                        path: baseDir + '/index/ordermanage/orderlist',
                        component: OrderList
                    },
                    {
                        name: 'feiyouorderlist',
                        path: baseDir + '/index/ordermanage/feiyouorderlist',
                        component: FeiYouOrderList
                    },
                    {
                        name: 'neworderlist',
                        path: baseDir + '/index/ordermanage/neworderlist',
                        component: NewOrderList
                    },
                    {
                        name: 'OrderInSystem',
                        path: baseDir + '/index/ordermanage/orderInSystem',
                        component: OrderInSystem
                    },
                    {
                        name: 'OrderServiceProvider',
                        path: baseDir + '/index/ordermanage/OrderServiceProvider',
                        component: OrderServiceProvider
                    },
                    {
                        name: 'purchaseorderlist',
                        path: baseDir + '/index/ordermanage/purchaseorderlist',
                        component: PurchaseOrderList
                    },
                    {
                        name: 'mypurchaseorder',
                        path: baseDir + '/index/ordermanage/mypurchaseorder',
                        component: MyPurchaseOrder
                    },
                    {
                        name: 'orderdetailcheck',
                        path: 'orderdetailcheck',
                        component: OrderDetailCheck
                    },
                    {
                        name: 'orderdetaillook',
                        path: 'orderdetaillook',
                        component: OrderDetailLook
                    },
                    {
                        name: 'maintainrecord',
                        path: baseDir + '/index/ordermanage/maintainrecord',
                        component: MaintainRecord
                    }
                ]
            },
            // 数据监控
            {
                name: 'datacontrol',
                path: baseDir + '/index/datacontrol',
                component: DataControl
            },
            // 配送管理
            {
                name: 'deliverymanage',
                path: baseDir + '/index/deliverymanage',
                component: DeliveryManage,
                redirect: baseDir + '/index/deliverymanage/deliverylist',
                children: [
                    {
                        name: 'deliverylist',
                        path: baseDir + '/index/deliverymanage/deliverylist',
                        component: DeliveryList
                    },
                    {
                        name: 'deliverysetting',
                        path: baseDir + '/index/deliverymanage/deliverysetting',
                        component: DeliverySetting
                    }
                ]
            },
            // 用户管理
            {
                name: 'usermanage',
                path: baseDir + '/index/usermanage',
                component: UserManage,
                redirect: baseDir + '/index/usermanage/userlist',
                children: [
                    {
                        name: 'userlist',
                        path: baseDir + '/index/usermanage/userlist',
                        component: UserList,
                    },
                    {
                        name: 'adduser',
                        path: baseDir + '/index/usermanage/adduser',
                        component: AddUser,
                    }
                ]
            },
            // 电子券管理
            {
                name: 'ticketmanage',
                path: baseDir + '/index/ticketmanage',
                component: TicketManage
            },
            // 营销管理
            {
                name: 'marketingmanage',
                path: baseDir + '/index/marketingmanage',
                component: MarketingManage
            },
            {
                name: 'msgrecordall',
                path: baseDir + '/index/msgrecordall',
                component: MsgRecordAll
            },
        ]
    },
    // 404
    {
        path: '*',
        redirect: baseDir+'/index'
    }
]
export default new Router({
    // mode: "history",
    routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js